
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptLaborDialog extends Common.GridEditorDialog<JobWorkReceiptLaborRow> {
        protected getFormKey() { return JobWorkReceiptLaborForm.formKey; }
        //protected getIdProperty() { return JobWorkReceiptLaborRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkReceiptLaborRow.localTextPrefix; }
        //protected getNameProperty() { return JobWorkReceiptLaborRow.nameProperty; }
        //protected getService() { return JobWorkReceiptLaborService.baseUrl; }
        protected getDeletePermission() { return JobWorkReceiptLaborRow.deletePermission; }
        protected getInsertPermission() { return JobWorkReceiptLaborRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkReceiptLaborRow.updatePermission; }

        protected form = new JobWorkReceiptLaborForm(this.idPrefix);

    }
}